import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Industries from "../pages/industries/page";
import Process from "../pages/process/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Terms from "../pages/terms/page";

const routes: RouteObject[] = [
  { path: "/",           element: <Home />       },
  { path: "/about",      element: <About />      },
  { path: "/services",   element: <Services />   },
  { path: "/industries", element: <Industries /> },
  { path: "/process",    element: <Process />    },
  { path: "/contact",    element: <Contact />    },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/terms",      element: <Terms />      },
  { path: "*",           element: <NotFound />   },
];

export default routes;
